/* eslint-disable @typescript-eslint/no-explicit-any */
type Event = React.SyntheticEvent<HTMLElement>;

export const callWithInputImage = (fn: Function) => (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();
  const input = e.currentTarget;
  const image = input && input.files && input.files[0];

  if (image) {
    input.value = null;
    fn(image);
  }
};

export const preventDefault = (fn: Function) => (e: Event, ...rest: any[]) => {
  e && e.preventDefault && e.preventDefault();
  fn(e, ...rest);
};
